import { render, staticRenderFns } from "./appHelpCenter.vue?vue&type=template&id=3ff49368&scoped=true"
import script from "./appHelpCenter.vue?vue&type=script&lang=js"
export * from "./appHelpCenter.vue?vue&type=script&lang=js"
import style0 from "./appHelpCenter.vue?vue&type=style&index=0&id=3ff49368&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff49368",
  null
  
)

export default component.exports